import { Modal } from '@zillow/constellation-10';
import { Toast, useToast } from '@zillow/constellation-10';
import { useCallback, useEffect } from 'react';

import { emitDownloadContractEvent } from '@/analytics/events';
import { useAuth } from '@/AuthProvider';

export enum IFrameEvents {
  Download = 'downloadClicked',
  Error = 'error',
}

export const PreviewContractModal = ({
  contractUrl,
  isOpen,
  onClose,
}: {
  contractUrl: string;
  isOpen: boolean;
  onClose: () => void;
}) => {
  const { user } = useAuth();
  const { enqueueToast } = useToast();

  const messageListener = useCallback(
    (msg: MessageEvent) => {
      const event: IFrameEvents = msg.data.event;

      switch (event) {
        case IFrameEvents.Download:
          if (user) emitDownloadContractEvent({ user });
          break;
        case IFrameEvents.Error:
          enqueueToast(<Toast tone="critical">Unexpected error...</Toast>);
          break;
        default:
          break;
      }
    },
    [enqueueToast, user],
  );

  const subscribeToMessages = useCallback(() => {
    if (window) {
      window.addEventListener('message', messageListener);
    }
  }, [messageListener]);

  const unsubscribeFromMessages = useCallback(() => {
    if (window) {
      window.removeEventListener('message', messageListener);
    }
  }, [messageListener]);

  useEffect(() => {
    subscribeToMessages();

    return () => {
      unsubscribeFromMessages();
    };
  }, [subscribeToMessages, unsubscribeFromMessages]);

  return (
    <Modal
      open={isOpen}
      onOpenChange={(isOpen) => {
        if (!isOpen) onClose();
      }}
      header="Document Preview"
      body={
        <iframe
          src={contractUrl}
          style={{
            height: 'calc(100vh - 200px)',
            boxShadow: 'none',
            border: 0,
            width: '100%',
          }}
        />
      }
    />
  );
};
